import React, { useState, useEffect, useRef } from "react";
import styles from "../Select/GeneralSelect.module.scss";
import { useField, Field } from "formik";
import selectArrow from "../../../static/icons/select-arrow.svg";
import selectArrowError from "../../../static/icons/select-arrow-error.svg";
import { useSetSearchCityHook } from "../../../utils/hooks";
import OptionsList from "./OptionsList";

const SelectCityV3 = ({ name, setCities, options, label, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const [isFocus, setIsFocus] = useState(false);
  const fieldWrapRef = useRef(null);
  useSetSearchCityHook(field.value, setCities);

  useEffect(() => {
    if (!field.value) {
      setCities([]);
    }
  }, [field.value]);

  useEffect(() => {
    if (isFocus) {
      fieldWrapRef.current.style.zIndex = "2";
    } else fieldWrapRef.current.style.zIndex = "0";
  }, [isFocus]);

  const onBlurHandler = (e) => {
    field.onBlur(e);
    setIsFocus(false);
    if (props.hasOwnProperty("setShouldPushPage")) {
      props.setShouldPushPage(false);
    }
  };

  const onChooseHandler = (value) => helpers.setValue(value);

  const isOptionsListOpen = isFocus && options.length !== 0 && field.value;
  const fieldError = meta.error && meta.touched && !isFocus;
  const arrowBtn = fieldError ? selectArrowError : selectArrow;
  const arrowBtnClass = isOptionsListOpen
    ? styles.openArrowBtn
    : styles.arrowBtn;

  return (
    <>
      <div
        className={styles.Select}
        data-invalid={fieldError}
        list-open={`${!!isOptionsListOpen}`}
        ref={fieldWrapRef}
        onClick={() => {
          setIsFocus(true);
          if (props.hasOwnProperty("setShouldPushPage")) {
            props.setShouldPushPage(true);
          }
        }}
      >
        <span className={styles.label}>{label}</span>
        <div className={styles.fieldWrap}>
          {props.hasOwnProperty("isBlack") ? (
            <Field
              name={name}
              className={styles.field1}
              onBlur={onBlurHandler}
              onFocus={() => setIsFocus(true)}
              placeholder="Type here..."
              autoComplete="off"
            />
          ) : (
            <Field
              name={name}
              className={styles.field}
              onBlur={onBlurHandler}
              onFocus={() => setIsFocus(true)}
              placeholder="Type here..."
              autoComplete="off"
            />
          )}
          <img src={arrowBtn} alt="Arrow" className={arrowBtnClass} />
        </div>
        {isOptionsListOpen && (
          <OptionsList options={options} onChooseHandler={onChooseHandler} />
        )}
      </div>
    </>
  );
};

export default SelectCityV3;